const facilities = {
  // HeroSection
  'facilities.hero.homeLink': 'ホーム',
  'facilities.hero.aboutLink': 'アカデミーについて',
  'facilities.hero.currentPage': '施設・設備紹介',
  'facilities.hero.title': '施設・設備紹介',
  'facilities.hero.titleEn': 'FACILITIES',
  'facilities.hero.lead': '本校は東京・お台場に位置し、講義と実技演習を行う学びの場です。東京・お台場の執事学校として、通学しやすい環境で施設をご覧いただけます。',
  'facilities.hero.imgAlt': '東京・お台場の本校、洗練された講義スペースの様子',

  // CampusSection
  'facilities.campus.label': 'OUR CAMPUS',
  'facilities.campus.title': 'どんな施設で学べるの？',
  'facilities.campus.titleEn': 'Campus in Odaiba, Tokyo',
  'facilities.campus.imgAlt': '定員6名の少人数制講義スペースに並ぶ机と椅子の様子',
  'facilities.campus.p1': '本校は、東京湾を望むお台場に位置します。落ち着いた環境の中で、講義と実技演習の双方に取り組める学びの場です。ゆりかもめ「東京国際クルーズターミナル駅」「テレコムセンター駅」より各徒歩約5分、臨海副都心の洗練された街並みの中に校舎を構えています。日本の執事学校の本校として、施設見学を通じて通学のイメージも具体化していただけます。',
  'facilities.campus.p2': '校内には、講義を行う教室スペースと、実際に手を動かして学ぶ実技演習スペースを備えています。受講生の皆様が集中して学べる落ち着いた環境を整え、定員6名の少人数制にふさわしい、密度の高い学びの空間を提供します。',
  'facilities.campus.p3': '校舎の見学は完全予約制で承っています。実際の雰囲気をご覧いただき、学びのイメージを具体化していただければ幸いです。見学は授業日（土日）以外の平日にも対応しております（所要時間の目安：30分程度）。',

  // FacilityCards
  'facilities.cards.label': 'TRAINING EQUIPMENT',
  'facilities.cards.title': '実技で使う設備',
  'facilities.cards.titleEn': 'Hands-on Training Facilities',
  'facilities.cards.lead': '執事の学びは、実際に手を動かしてこそ身につきます。テーブルセッティングからティーサービス、衣類のケアまで、実習に必要な環境を整えています。',
  'facilities.cards.preparing': '準備中',
  'facilities.cards.0.title': 'テーブルセッティング演習什器',
  'facilities.cards.0.description': 'フォーマルからカジュアルまで、シーンに応じたテーブルコーディネートを学ぶための什器を備えています。カトラリーやグラスの配置、ナプキンの折り方まで、実際に手を動かしながら習得します。',
  'facilities.cards.1.title': 'ティー・コーヒーサービス設備',
  'facilities.cards.1.description': '紅茶やコーヒーの適切な抽出から、美しいサーブの所作までを実習できる設備を整えています。温度管理や注ぎ方、ゲストへの所作まで、一連の流れを体得します。',
  'facilities.cards.2.title': '衣類ケア実習環境',
  'facilities.cards.2.description': 'アイロンがけやスチーマーの取り扱い、衣類の素材に応じた適切なケア方法を学ぶ実習環境です。シャツの仕上げからスーツの手入れまで、執事に求められる衣類管理の技術を習得します。',
  'facilities.cards.3.title': 'ロールプレイング用スペース',
  'facilities.cards.3.description': '実際の邸宅やホテルの場面を想定したロールプレイング演習を行うスペースです。講師がゲスト役となり、受講生の皆様が執事として対応する実践的な訓練を繰り返し行います。',
  'facilities.cards.4.title': '来客対応・出迎え演習エリア',
  'facilities.cards.4.description': 'エントランスでの出迎えから、コートのお預かり、お見送りまでの所作を実習するエリアです。第一印象を左右する出迎えの技術を、実際の動線に沿って体得します。',
  'facilities.cards.5.title': 'ワイン・飲料サービス演習設備',
  'facilities.cards.5.description': 'ワインの適切な開栓やデキャンタージュ、グラスへの注ぎ方など、飲料サービスに特化した実習環境を準備中です。テイスティングの基本知識もあわせて学べる設備を予定しています。',

  // StudioSection
  'facilities.studio.label': 'PRACTICE STUDIO',
  'facilities.studio.title': '実習スタジオについて',
  'facilities.studio.titleEn': 'Real-world Simulation Space',
  'facilities.studio.p1': 'ロールプレイングによる実践的な訓練をより効果的に行うため、実際の邸宅やホテルの場面を想定した環境での実習を予定しています。講師がゲスト役を務め、受講生の皆様が執事として一連のサービスを提供する——このリアルな演習を通じて、判断力と対応力を養います。',
  'facilities.studio.p2': '実習スタジオの具体的な設備・仕様については開校に向けて準備を進めており、詳細が決まり次第、本ページでご案内いたします。',
  'facilities.studio.note': '※都内の環境を活用予定（詳細は準備中）',

  // TourGuide
  'facilities.tour.label': 'CAMPUS TOUR',
  'facilities.tour.title': '見学のご案内',
  'facilities.tour.titleEn': 'Visit Our Campus',
  'facilities.tour.lead': '校舎の雰囲気は、実際にご覧いただくのが一番です。完全予約制で見学を承っていますので、お気軽にお問い合わせください。',
  'facilities.tour.booking.label': '見学受付',
  'facilities.tour.booking.text': '完全予約制です。授業日（土日）以外の平日にも対応しております。',
  'facilities.tour.duration.label': '所要時間',
  'facilities.tour.duration.text': '30分程度を目安としています。',
  'facilities.tour.how.label': 'ご予約方法',
  'facilities.tour.how.text': 'お問い合わせフォーム、またはお電話（03-6824-4086・平日10:00〜17:00）にて承ります。',
  'facilities.tour.note.label': 'ご注意',
  'facilities.tour.note.text': '完全予約制のため、事前のご予約がない場合は校舎内をご覧いただけません。必ず事前にご連絡くださいますようお願いいたします。',
  'facilities.tour.accessLink': 'アクセス情報を見る',

  // FAQSection
  'facilities.faq.label': 'FAQ',
  'facilities.faq.title': 'よくあるご質問',
  'facilities.faq.titleEn': 'Frequently Asked Questions',
  'facilities.faq.footer': 'その他のご質問はフォームよりお寄せください',
  'facilities.faq.0.question': '施設の見学はできますか？',
  'facilities.faq.0.answer': 'はい。完全予約制で見学を承っています。お問い合わせフォームまたはお電話（平日10:00〜17:00）よりご予約ください。',
  'facilities.faq.1.question': '実技の設備は整っていますか？',
  'facilities.faq.1.answer': 'テーブルセッティングやティーサービス、衣類ケアなどの実習に必要な環境を整えています（一部は開校に向けて準備中です）。',
  'facilities.faq.2.question': '校舎はどこにありますか？',
  'facilities.faq.2.answer': '東京・お台場（江東区青海）にあります。最寄りはゆりかもめ「東京国際クルーズターミナル駅」「テレコムセンター駅」で、各徒歩約5分です。',

  // CTASection
  'facilities.cta.label': 'NEXT STEP',
  'facilities.cta.title': '実際にご覧になりませんか',
  'facilities.cta.body': '校舎の見学は完全予約制で承っています。アクセスのご確認や、個別相談のご予約もお気軽にどうぞ。',
  'facilities.cta.note': '※ご相談はオンラインでも承ります',
  'facilities.cta.access': 'アクセスを見る',
  'facilities.cta.consultation': '見学・相談を予約する',

  // RelatedPages
  'facilities.related.label': 'LEARN MORE',
  'facilities.related.title': '関連ページ',
  'facilities.related.titleEn': 'Explore Further',
  'facilities.related.viewLink': '詳しく見る',
  'facilities.related.0.title': 'アクセス',
  'facilities.related.0.desc': '校舎への行き方と完全予約制のご案内',
  'facilities.related.1.title': 'アカデミー概要',
  'facilities.related.1.desc': '日本執事アカデミーの全体像',
  'facilities.related.2.title': '実践トレーニング',
  'facilities.related.2.desc': '現場を想定した実践的な学び',
  'facilities.related.3.title': '個別相談予約',
  'facilities.related.3.desc': 'オンライン可・無料の個別相談',

  // Last updated
  'facilities.lastUpdated': '最終更新: 2026年7月8日',
};

export default facilities;
